import { Int } from '@adornis/baseql/baseqlTypes.js';
import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { watchQuery } from '@adornis/baseql/server/watchQuery.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { switchMap } from 'rxjs';
import { Draft } from '../db/Draft.js';
import { DraftListFilter } from '../db/DraftListFilter.js';

export const subscribeReviewDrafts = registerSubscription({
  type: () => [Draft],
  operationName: 'subscribeReviewDrafts',
  resolve: (skip: number, limit: number, filter?: DraftListFilter) => {
    return (gqlFields: BaseQLSelectionSet<Draft>) => {
      if (!filter?.draftClassName) throw new Error('draftClassName is required');

      const matchFilter = {
        _class: filter.draftClassName,
        ...(filter?.referenceID ? { referenceID: filter.referenceID } : {}),
        ...(filter?.status && filter.status.length > 0 ? { 'status.name': { $in: filter.status } } : {}),
      };

      return watchQuery<Draft>(Draft._collectionName, matchFilter).pipe(
        switchMap(async () => {
          const rawDrafts = await getRawCollection<Draft>(Draft._collectionName);
          const drafts = await rawDrafts
            .aggregate([
              {
                $match: matchFilter,
              },
              {
                $addFields: {
                  lastModified: { $ifNull: ['$updatedAt', '$createdAt'] },
                },
              },
              { $sort: { lastModified: -1 } },
            ])
            .toArray();
          return drafts;
        }),
      );
    };
  },
  params: [
    { type: () => Int, name: 'skip' },
    { type: () => Int, name: 'limit' },
    { type: () => DraftListFilter, name: 'filter' },
  ],
});
